export type FilterKey =
  | "100won"
  | "good_sangjo"
  | "funeral_prep"
  | "funeral_now";

// ---------- 필터 칩 ----------
export const FILTERS: { key: FilterKey; label: string }[] = [
  { key: "100won", label: "100원 상조가 궁금해요" },
  { key: "good_sangjo", label: "좋은 상조 고르는 법" },
  { key: "funeral_prep", label: "장례 준비 지금 필요할까?" },
  { key: "funeral_now", label: "장례를 준비중이라면" },
];

// ---------- Series (가로 스크롤 카드) ----------
export interface SeriesCard {
  id: string;
  title: string;
  description: string;
  tags: string[];
  thumbnailSrc?: string;
  thumbnailBg: string;
  href: string;
  duration?: string; // 설정 시 비디오 뱃지 표시
}

export interface Series {
  key: string;
  title: string;
  cards: SeriesCard[];
}

export const SERIES: Series[] = [
  {
    key: "100won",
    title: "고이와 100원 상조",
    cards: [
      {
        id: "100won-reason",
        title: "100원 상조가 세상에 나온 이유",
        description: "어떻게 100원으로 상조 운영이 가능할까요?",
        tags: ["고이", "100원 상조"],
        thumbnailBg: "#9099a5",
        thumbnailSrc: "direct/feed/100won-reason.png",
        href: "/content/feeds/100sangjo/",
      },
      {
        id: "goi-promise",
        title: "투명한 장례를 위한 고이의 약속",
        description: "다른 상조와 고이는 어떻게 다를까요?",
        tags: ["고이", "좋은 상조의 기준"],
        thumbnailBg: "#d1cac9",
        thumbnailSrc: "direct/feed/goi-promise.png",
        href: "/content/feeds/about-promise/",
      },
      {
        id: "goi-trust",
        title: "고이, 믿을 수 있나요?",
        description: "업계 최초 119억 투자, 10만명이 가입한 초고속 성장 고이.",
        tags: ["고이"],
        thumbnailBg: "#e3f2ff",
        thumbnailSrc: "direct/feed/goi-trust.png",
        href: "/introduce/new/",
      },
      {
        id: "ceo-youtube",
        title: "[영상] 고이 CEO 인터뷰",
        description: "부모님의 장례식은 특별하게 치러주고 싶었어요.",
        tags: ["고이", "영상", "인터뷰"],
        thumbnailBg: "#c9d4e0",
        thumbnailSrc: "direct/feed/ceo-youtube.png",
        href: "https://www.youtube.com/watch?v=PPhQUcQYFKU",
        duration: "11분 소요",
      },
      {
        id: "ceo-youtube-2",
        title: "[영상] 서울대 출신 장례 지도사가 IT로 시장을 혁신하는 법",
        description: "구조를 바꾸고 싶어 시작한 장례 서비스",
        tags: ["고이", "영상", "인터뷰"],
        thumbnailBg: "#b8c4d0",
        thumbnailSrc: "direct/feed/ceo-youtube-2.png",
        href: "https://www.youtube.com/watch?v=4HewyN5mJOg&t=33s",
        duration: "13분 소요",
      },
    ],
  },
  {
    key: "funeral_need",
    title: "장례 준비가 필요한 이유",
    cards: [
      {
        id: "urgent-funeral",
        title: "갑자기 오는 장례, 준비가 없으면 후회만 남습니다",
        description: "장례를 미리 준비하지 않으면 무슨일이 생길까요?",
        tags: ["장례 준비의 필요성", "장례 비용"],
        thumbnailBg: "#e8edf5",
        thumbnailSrc: "direct/feed/urgent-funeral.png",
        href: "/content/feeds/prepare/1/",
      },
      {
        id: "funeral-cost",
        title: "장례 비용을 아끼는 가장 확실한 방법",
        description: "모든 비용이 오르는데, 장례는 예외일까요?",
        tags: ["장례 준비의 필요성", "장례 비용"],
        thumbnailBg: "#f5f0e8",
        thumbnailSrc: "direct/feed/funeral-cost.png",
        href: "/content/feeds/prepare/2/",
      },
      {
        id: "good-sangjo",
        title: "좋은 상조 회사, 이렇게 고르세요",
        description:
          "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
        tags: ["장례 준비의 필요성", "장례 비용"],
        thumbnailBg: "#f0f0f0",
        thumbnailSrc: "direct/feed/good-sangjo.png",
        href: "/content/feeds/prepare/3/",
      },
    ],
  },
  {
    key: "funeral_start",
    title: "장례 준비를 시작한다면",
    cards: [
      {
        id: "sn-1",
        title: "장례 가이드북 1편 - 장례 전",
        description: "장례 준비, 무엇부터 시작해야 할까요?",
        tags: ["장례 가이드"],
        thumbnailBg: "#e8edf5",
        thumbnailSrc: "direct/feed/sn-1.png",
        href: "/content/guide/sn-1/",
      },
      {
        id: "sn-2",
        title: "장례 가이드북 2편 - 임종 전",
        description: "임종 전/후로 어떻게 대처해야 할까요?",
        tags: ["장례 가이드"],
        thumbnailBg: "#e3f2ff",
        thumbnailSrc: "direct/feed/sn-2.png",
        href: "/content/guide/sn-2/",
      },
      {
        id: "sangjo-service",
        title: "상조 서비스, 한번에 정리해드립니다",
        description: "상조 서비스가 무엇인지부터 선택 기준까지.",
        tags: ["장례 가이드", "좋은 상조의 기준"],
        thumbnailBg: "#d1cac9",
        thumbnailSrc: "direct/feed/sangjo-service.png",
        href: "/content/feeds/sangjo-join/",
      },
      {
        id: "funeral-cost-video",
        title: "[영상] 장례식 비용, 얼마나 들까요?",
        description: "장례식 비용을 5분안에 완벽하게 정리했어요.",
        tags: ["장례 가이드", "장례 비용", "영상"],
        thumbnailBg: "#f5c842",
        thumbnailSrc: "direct/feed/funeral-cost-video.png",
        href: "https://www.youtube.com/watch?v=oQoEu-1gk18&feature=youtu.be",
        duration: "5분 소요",
      },
      {
        id: "funeral-beginner-video",
        title: "[영상] 장례식이 처음이라면?",
        description: "상조와 장례식장의 차이를 2분에 알기쉽게 보세요.",
        tags: ["장례 가이드", "영상"],
        thumbnailBg: "#e0ede0",
        thumbnailSrc: "direct/feed/funeral-beginner-video.png",
        href: "https://www.youtube.com/watch?v=q6Ka8vWFJ6I",
        duration: "2분 소요",
      },
      {
        id: "condolence-video",
        title: "[영상] 장례식장 조문 예절 완벽 정리",
        description: "11년차 장례지도사가 3분만에 조문 예절을 알려드려요.",
        tags: ["장례 가이드", "영상"],
        thumbnailBg: "#e8e0d0",
        thumbnailSrc: "direct/feed/condolence-video.png",
        href: "https://www.youtube.com/watch?v=UtMLHutEhE8&feature=youtu.be",
        duration: "3분 소요",
      },
    ],
  },
  {
    key: "media",
    title: "미디어가 본 고이",
    cards: [
      {
        id: "news-chosun",
        title:
          "장례 시장의 파격, 32세 청년이 만든 100원 상조에 119억원 투자 몰려",
        description: "2026.03.26 | 조선일보",
        tags: ["고이", "인터뷰"],
        thumbnailBg: "#c8cdd4",
        thumbnailSrc: "direct/feed/news-chosun.png",
        href: "https://news.naver.com/article/023/0003966901",
      },
      {
        id: "news-maeil",
        title: `"바가지 장례요금, 상중에 따질수도 없고"...'투명한 정찰제' 상조 뜬다`,
        description: "2026.02.20 | 매일경제",
        tags: ["고이", "인터뷰"],
        thumbnailBg: "#d4cdc8",
        thumbnailSrc: "direct/feed/news-maeil.png",
        href: "https://n.news.naver.com/article/009/0005639167",
      },
      {
        id: "news-venture",
        title:
          "정찰제·후불제·100원 상조로 장례 산업의 공식을 바꾸는 고이장례연구소 송슬기 대표",
        description: "2026.02.20 | 벤처스퀘어",
        tags: ["고이", "인터뷰"],
        thumbnailBg: "#c8d0cc",
        thumbnailSrc: "direct/feed/news-venture.png",
        href: "https://www.venturesquare.net/1039433/",
      },
    ],
  },
];

// ---------- All Contents (수직 카드 리스트) ----------
export interface AllContentCard {
  id: string;
  title: string;
  description: string;
  tags: string[];
  thumbnailSrc?: string;
  thumbnailBg: string;
  href: string;
  duration?: string;
}

export const ALL_CONTENTS: AllContentCard[] = [
  // Series 1: 고이와 100원 상조
  {
    id: "100won-reason",
    title: "100원 상조가 세상에 나온 이유",
    description: "어떻게 100원으로 상조 운영이 가능할까요?",
    tags: ["고이", "100원 상조"],
    thumbnailBg: "#9099a5",
    thumbnailSrc: "direct/feed/100won-reason.png",
    href: "/content/feeds/100sangjo/",
  },
  {
    id: "goi-promise",
    title: "투명한 장례를 위한 고이의 약속",
    description: "다른 상조와 고이는 어떻게 다를까요?",
    tags: ["고이", "좋은 상조의 기준"],
    thumbnailBg: "#d1cac9",
    thumbnailSrc: "direct/feed/goi-promise.png",
    href: "/content/feeds/prepare/2/",
  },
  {
    id: "goi-trust",
    title: "고이, 믿을 수 있나요?",
    description: "업계 최초 119억 투자, 10만명이 가입한 초고속 성장 고이.",
    tags: ["고이"],
    thumbnailBg: "#e3f2ff",
    thumbnailSrc: "direct/feed/goi-trust.png",
    href: "/content/feeds/prepare/3/",
  },
  {
    id: "ceo-youtube",
    title: "[영상] 고이 CEO 인터뷰",
    description: "부모님의 장례식은 특별하게 치러주고 싶었어요.",
    tags: ["고이", "영상", "인터뷰"],
    thumbnailBg: "#c9d4e0",
    thumbnailSrc: "direct/feed/ceo-youtube.png",
    href: "https://www.youtube.com/watch?v=PPhQUcQYFKU",
    duration: "11분 소요",
  },
  {
    id: "ceo-youtube-2",
    title: "[영상] 서울대 출신 장례 지도사가 IT로 시장을 혁신하는 법",
    description: "구조를 바꾸고 싶어 시작한 장례 서비스",
    tags: ["고이", "영상", "인터뷰"],
    thumbnailBg: "#b8c4d0",
    thumbnailSrc: "direct/feed/ceo-youtube-2.png",
    href: "https://www.youtube.com/watch?v=4HewyN5mJOg&t=33s",
    duration: "13분 소요",
  },
  // Series 2: 장례 준비가 필요한 이유
  {
    id: "urgent-funeral",
    title: "갑자기 오는 장례, 준비가 없으면 후회만 남습니다",
    description: "장례를 미리 준비하지 않으면 무슨일이 생길까요?",
    tags: ["장례 준비의 필요성", "장례 비용"],
    thumbnailBg: "#e8edf5",
    thumbnailSrc: "direct/feed/urgent-funeral.png",
    href: "/content/feeds/prepare/1/",
  },
  {
    id: "funeral-cost",
    title: "장례 비용을 아끼는 가장 확실한 방법",
    description: "모든 비용이 오르는데, 장례는 예외일까요?",
    tags: ["장례 준비의 필요성", "장례 비용"],
    thumbnailBg: "#f5f0e8",
    thumbnailSrc: "direct/feed/funeral-cost.png",
    href: "/content/feeds/about-promise/",
  },
  {
    id: "good-sangjo",
    title: "좋은 상조 회사, 이렇게 고르세요",
    description:
      "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
    tags: ["장례 준비의 필요성", "장례 비용"],
    thumbnailBg: "#f0f0f0",
    thumbnailSrc: "direct/feed/good-sangjo.png",
    href: "/content/feeds/prepare/3/",
  },
  // Series 3: 장례 준비를 시작한다면
  {
    id: "sn-1",
    title: "장례 가이드북 1편 - 장례 전",
    description: "장례 준비, 무엇부터 시작해야 할까요?",
    tags: ["장례 가이드"],
    thumbnailBg: "#e8edf5",
    thumbnailSrc: "direct/feed/sn-1.png",
    href: "/content/guide/sn-1/",
  },
  {
    id: "sn-2",
    title: "장례 가이드북 2편 - 임종 전",
    description: "임종 전/후로 어떻게 대처해야 할까요?",
    tags: ["장례 가이드"],
    thumbnailBg: "#e3f2ff",
    thumbnailSrc: "direct/feed/sn-2.png",
    href: "/content/guide/sn-2/",
  },
  {
    id: "sangjo-service",
    title: "상조 서비스, 한번에 정리해드립니다",
    description: "상조 서비스가 무엇인지부터 선택 기준까지.",
    tags: ["장례 가이드", "좋은 상조의 기준"],
    thumbnailBg: "#d1cac9",
    thumbnailSrc: "direct/feed/sangjo-service.png",
    href: "/content/feeds/sangjo-join/",
  },
  {
    id: "funeral-cost-video",
    title: "[영상] 장례식 비용, 얼마나 들까요?",
    description: "장례식 비용을 5분안에 완벽하게 정리했어요.",
    tags: ["장례 가이드", "장례 비용", "영상"],
    thumbnailBg: "#f5c842",
    thumbnailSrc: "direct/feed/funeral-cost-video.png",
    href: "https://www.youtube.com/watch?v=oQoEu-1gk18&feature=youtu.be",
    duration: "5분 소요",
  },
  {
    id: "funeral-beginner-video",
    title: "[영상] 장례식이 처음이라면?",
    description: "상조와 장례식장의 차이를 2분에 알기쉽게 보세요.",
    tags: ["장례 가이드", "영상"],
    thumbnailBg: "#e0ede0",
    thumbnailSrc: "direct/feed/funeral-beginner-video.png",
    href: "https://www.youtube.com/watch?v=q6Ka8vWFJ6I",
    duration: "2분 소요",
  },
  {
    id: "condolence-video",
    title: "[영상] 장례식장 조문 예절 완벽 정리",
    description: "11년차 장례지도사가 3분만에 조문 예절을 알려드려요.",
    tags: ["장례 가이드", "영상"],
    thumbnailBg: "#e8e0d0",
    thumbnailSrc: "direct/feed/condolence-video.png",
    href: "https://www.youtube.com/watch?v=UtMLHutEhE8&feature=youtu.be",
    duration: "3분 소요",
  },
  // Series 4: 미디어가 본 고이
  {
    id: "news-chosun",
    title: "장례 시장의 파격, 32세 청년이 만든 100원 상조에 119억원 투자 몰려",
    description: "2026.03.26 | 조선일보",
    tags: ["고이", "인터뷰"],
    thumbnailBg: "#c8cdd4",
    thumbnailSrc: "direct/feed/news-chosun.png",
    href: "https://news.naver.com/article/023/0003966901",
  },
  {
    id: "news-maeil",
    title: `"바가지 장례요금, 상중에 따질수도 없고"...'투명한 정찰제' 상조 뜬다`,
    description: "2026.02.20 | 매일경제",
    tags: ["고이", "인터뷰"],
    thumbnailBg: "#d4cdc8",
    thumbnailSrc: "direct/feed/news-maeil.png",
    href: "https://n.news.naver.com/article/009/0005639167",
  },
  {
    id: "news-venture",
    title:
      "정찰제·후불제·100원 상조로 장례 산업의 공식을 바꾸는 고이장례연구소 송슬기 대표",
    description: "2026.02.20 | 벤처스퀘어",
    tags: ["고이", "인터뷰"],
    thumbnailBg: "#c8d0cc",
    thumbnailSrc: "direct/feed/news-venture.png",
    href: "https://www.venturesquare.net/1039433/",
  },
];

export const TAG_FILTER_OPTIONS: { key: string; label: string }[] = [
  { key: "전체", label: "컨텐츠 전체" },
  { key: "고이와 100원상조", label: "고이와 100원상조" },
  { key: "장례 준비의 필요성", label: "장례 준비의 필요성" },
  { key: "장례 비용", label: "장례 비용" },
  { key: "좋은 상조의 기준", label: "좋은 상조의 기준" },
  { key: "장례 가이드", label: "장례 가이드" },
  { key: "인터뷰", label: "인터뷰" },
  { key: "영상", label: "영상" },
];

export function getFilteredContents(tagKey: string): AllContentCard[] {
  if (tagKey === "전체") return ALL_CONTENTS;
  if (tagKey === "고이와 100원상조") {
    return ALL_CONTENTS.filter(
      (item) => item.tags.includes("고이") || item.tags.includes("100원 상조")
    );
  }
  return ALL_CONTENTS.filter((item) => item.tags.includes(tagKey));
}

// ---------- FAQ ----------
export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: "faq-1",
    question: "100원 상조가 정말 100원인가요?",
    answer:
      "네, 월 100원으로 상조 서비스를 이용할 수 있습니다. 고이 프라임은 투명한 가격 정책으로 운영되며, 숨겨진 비용이 없습니다.",
  },
  {
    id: "faq-2",
    question: "장례 비용은 얼마나 드나요?",
    answer:
      "장례 비용은 장례 방식, 장례식장, 지역에 따라 달라집니다. 고이를 통해 미리 견적을 받아보시면 더 정확한 비용을 확인할 수 있습니다.",
  },
  {
    id: "faq-3",
    question: "상조와 장례식장의 차이는 무엇인가요?",
    answer:
      "상조 회사는 장례 서비스를 제공하는 업체이고, 장례식장은 장례를 진행하는 시설입니다. 상조를 이용하면 장례식장 선택, 장례 진행 등을 대행해드립니다.",
  },
  {
    id: "faq-4",
    question: "장례 준비는 언제부터 해야 하나요?",
    answer:
      "가능한 빨리 준비하는 것이 좋습니다. 갑작스러운 장례에 대비해 미리 준비하면 비용도 절약하고 당황하지 않을 수 있습니다.",
  },
];

// ---------- 필터 선택 시 카드 리스트 ----------
export interface ArticleItem {
  type: "article";
  id: string;
  title: string;
  description: string;
  tags: string[];
  imgSrc: string;
  href: string;
  thumbnailBg?: string;
}

export interface VideoItem {
  type: "video";
  id: string;
  title: string;
  description: string;
  tags: string[];
  imgSrc: string;
  href: string;
  duration: string;
  thumbnailBg?: string;
}

export interface NewsItem {
  type: "news";
  id: string;
  title: string;
  imgSrc: string;
  href: string;
  date: string;
  source: string;
}

export type ContentItem = ArticleItem | VideoItem | NewsItem;

export const CONTENT_DATA: Record<FilterKey, ContentItem[]> = {
  funeral_now: [
    {
      type: "article",
      id: "sn-1",
      title: "장례 가이드북 1편 - 장례 전",
      description: "장례 준비, 무엇부터 시작해야 할까요?",
      tags: ["장례 가이드"],
      imgSrc: "direct/feed/sn-1.png",
      href: "/content/guide/sn-1/",
    },
    {
      type: "article",
      id: "sn-2",
      title: "장례 가이드북 2편 - 임종 전",
      description: "임종 전/후로 어떻게 대처해야 할까요?",
      tags: ["장례 가이드"],
      imgSrc: "direct/feed/sn-2.png",
      href: "/content/guide/sn-2/",
    },
    {
      type: "article",
      id: "good-sangjo",
      title: "좋은 상조 회사, 이렇게 고르세요",
      description:
        "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/good-sangjo.png",
      href: "/content/feeds/prepare/3/",
    },
    {
      type: "video",
      id: "funeral-cost-video",
      title: "[영상] 장례식 비용, 얼마나 들까요?",
      description: "장례식 비용을 5분안에 완벽하게 정리했어요.",
      tags: ["장례 가이드", "장례 비용", "영상"],
      imgSrc: "direct/feed/funeral-cost-video.png",
      href: "https://www.youtube.com/watch?v=oQoEu-1gk18&feature=youtu.be",
      duration: "5분 소요",
    },
    {
      type: "video",
      id: "funeral-beginner-video",
      title: "[영상] 장례식이 처음이라면?",
      description: "상조와 장례식장의 차이를 2분에 알기쉽게 보세요.",
      tags: ["장례 가이드", "영상"],
      imgSrc: "direct/feed/funeral-beginner-video.png",
      href: "https://www.youtube.com/watch?v=q6Ka8vWFJ6I",
      duration: "2분 소요",
    },
  ],
  funeral_prep: [
    {
      type: "article",
      id: "urgent-funeral",
      title: "갑자기 오는 장례, 준비가 없으면 후회만 남습니다",
      description: "장례를 미리 준비하지 않으면 무슨일이 생길까요?",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/urgent-funeral.png",
      href: "/content/feeds/prepare/1/",
    },
    {
      type: "article",
      id: "funeral-cost",
      title: "장례 비용을 아끼는 가장 확실한 방법",
      description: "모든 비용이 오르는데, 장례는 예외일까요?",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/funeral-cost.png",
      href: "/content/feeds/about-promise/",
    },
    {
      type: "article",
      id: "good-sangjo",
      title: "좋은 상조 회사, 이렇게 고르세요",
      description:
        "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/good-sangjo.png",
      href: "/content/feeds/prepare/3/",
    },
  ],
  good_sangjo: [
    {
      type: "article",
      id: "sangjo-service",
      title: "상조 서비스, 한번에 정리해드립니다",
      description: "상조 서비스가 무엇인지부터 선택 기준까지.",
      tags: ["장례 가이드", "좋은 상조의 기준"],
      imgSrc: "direct/feed/sangjo-service.png",
      href: "/content/feeds/sangjo-join/",
    },
    {
      type: "article",
      id: "good-sangjo",
      title: "좋은 상조 회사, 이렇게 고르세요",
      description:
        "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/good-sangjo.png",
      href: "/content/feeds/prepare/3/",
    },
    {
      type: "article",
      id: "goi-promise",
      title: "투명한 장례를 위한 고이의 약속",
      description: "다른 상조와 고이는 어떻게 다를까요?",
      tags: ["고이", "좋은 상조의 기준"],
      imgSrc: "direct/feed/goi-promise.png",
      href: "/content/feeds/prepare/2/",
    },
  ],
  "100won": [
    {
      type: "article",
      id: "100won-reason",
      title: "100원 상조가 세상에 나온 이유",
      description: "어떻게 100원으로 상조 운영이 가능할까요?",
      tags: ["고이", "100원 상조"],
      imgSrc: "direct/feed/100won-reason.png",
      href: "/content/feeds/100sangjo/",
    },
    {
      type: "article",
      id: "goi-promise",
      title: "투명한 장례를 위한 고이의 약속",
      description: "다른 상조와 고이는 어떻게 다를까요?",
      tags: ["고이", "좋은 상조의 기준"],
      imgSrc: "direct/feed/goi-promise.png",
      href: "/content/feeds/prepare/2/",
    },
    {
      type: "article",
      id: "goi-trust",
      title: "고이, 믿을 수 있나요?",
      description: "업계 최초 119억 투자, 10만명이 가입한 초고속 성장 고이.",
      tags: ["고이"],
      imgSrc: "direct/feed/goi-trust.png",
      href: "/content/feeds/prepare/3/",
    },
    {
      type: "article",
      id: "good-sangjo",
      title: "좋은 상조 회사, 이렇게 고르세요",
      description:
        "어떤 상조 회사가 좋은지 비교할 때 꼭 확인해야 하는 4가지 기준을 정리해드려요.",
      tags: ["장례 준비의 필요성", "장례 비용"],
      imgSrc: "direct/feed/good-sangjo.png",
      href: "/content/feeds/prepare/3/",
    },
    {
      type: "article",
      id: "news-chosun",
      title:
        "장례 시장의 파격, 32세 청년이 만든 100원 상조에 119억원 투자 몰려",
      description: "2026.03.26 | 조선일보",
      tags: ["고이", "인터뷰"],
      imgSrc: "direct/feed/news-chosun.png",
      href: "https://news.naver.com/article/023/0003966901",
    },
    {
      type: "article",
      id: "news-maeil",
      title: `"바가지 장례요금, 상중에 따질수도 없고"...'투명한 정찰제' 상조 뜬다`,
      description: "2026.02.20 | 매일경제",
      tags: ["고이", "인터뷰"],
      imgSrc: "direct/feed/news-maeil.png",
      href: "https://n.news.naver.com/article/009/0005639167",
    },
    {
      type: "article",
      id: "news-venture",
      title:
        "정찰제·후불제·100원 상조로 장례 산업의 공식을 바꾸는 고이장례연구소 송슬기 대표",
      description: "2026.02.20 | 벤처스퀘어",
      tags: ["고이", "인터뷰"],
      imgSrc: "direct/feed/news-venture.png",
      href: "https://www.venturesquare.net/1039433/",
    },
  ],
};
